import { get, post} from './request'

interface ContactPerson {
    supplier: string;
    propertyId: string;
    property: {
      contactperson: {
        propertylevelcontacts: Array<object>,
        chainlevelcontacts: Array<object>
      }
    };
}

export const getContactPerson = (supplier: string, propertyid: string) => get(`/property/contactperson?supplier=${supplier}&propertyid=${propertyid}`)
export const addContactPerson = (contactperson: ContactPerson) => post('/property/contactperson', contactperson)